import axios from '../../../../shared/axios';

import { AppDispatch } from '../../../../store';

import * as actionTypes from '../constants/actionTypes';

const markNotificationAsReadStart = () => {
  return {
    type: actionTypes.MARK_NOTIFICATION_AS_READ_START,
  };
};

const markNotificationAsReadSuccess = (data: any) => {
  return {
    type: actionTypes.MARK_NOTIFICATION_AS_READ_SUCCESS,
    notifications: data,
  };
};

const markNotificationAsReadFail = (error: any) => {
  return {
    type: actionTypes.MARK_NOTIFICATION_AS_READ_FAIL,
    error: error,
  };
};

export const markNotificationAsRead = (notificationId: string, isSystemMessage: boolean) => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(markNotificationAsReadStart());
      const url = `reminder-notifications/mark-as-read/${notificationId}/${isSystemMessage}`;

      axios
        .post(url)
        .then((response) => {
          dispatch(markNotificationAsReadSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(markNotificationAsReadFail(err));
          reject(err);
        });
    });
  };
};

const markAsRemindLaterStart = () => {
  return {
    type: actionTypes.MARK_AS_REMIND_LATER_START,
  };
};

const markAsRemindLaterSuccess = (data: any) => {
  return {
    type: actionTypes.MARK_AS_REMIND_LATER_SUCCESS,
    notifications: data,
  };
};

const markAsRemindLaterFail = (error: any) => {
  return {
    type: actionTypes.MARK_AS_REMIND_LATER_FAIL,
    error: error,
  };
};

export const markAsRemindLater = (notificationId: string) => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(markAsRemindLaterStart());
      const url = `reminder-notifications/remind-later/${notificationId}`;

      axios
        .post(url)
        .then((response) => {
          dispatch(markAsRemindLaterSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(markAsRemindLaterFail(err));
          reject(err);
        });
    });
  };
};
